@if (
  {
    trackers: trackers$ | async,
    selectedTracker: selectedTracker$ | async,
    selectedMetric: selectedMetric$ | async,
    selectedFilteredTrackerMetrics: selectedFilteredTrackerMetrics$ | async
  };
  as state
) {
  <div class="main-container" [class.error]="error" [class.show-hover]="!triggerFormGroup.get('trackerId').value">
    @if (!triggerFormGroup.get('trackerId').value) {
      <div class="autocomplete-container">
        <mat-icon svgIcon="tracker"></mat-icon>
        <oph-autocomplete
          placeholder="Choose a tracker"
          [options]="autocompleteOptions$ | async"
          [style]="ophAutocompleteStyle || defaultOphAutocompleteStyle"
          [hideSearchIcon]="true"
          (optionChange)="onTracker($event)"
        ></oph-autocomplete>

        <button
          *userHasRoleOption="rolePermissionOptions.Trackers"
          class="new-button"
          (click)="newClick.emit()"
          [disabled]="newButtonDisabled"
          [class.disabled-new-button]="newButtonDisabled"
        >
          @if (ophAutocompleteNewButtonLoading) {
            <div class="oph-orange-spinner">
              <mat-spinner [diameter]="23" [strokeWidth]="2"></mat-spinner>
            </div>
          } @else {
            <oph-icon [name]="'plus-orange'" [size]="20"></oph-icon>
            New
          }
        </button>
      </div>
    } @else {
      <img class="bolt-icon" src="assets/img/icons/bolt-2.svg" />
      <div class="metric-buttons-container">
        <!-- --------------------METRIC--------------------------- -->
        <button class="select-button" [matMenuTriggerFor]="metricMenu">
          <span>{{ state.selectedMetric?.name || 'Select metric' }}</span>
          <img src="assets/img/icons/chevron-down-brown.svg" />
        </button>
        <mat-menu #metricMenu="matMenu" class="oph-select-menu">
          @for (metric of state.selectedFilteredTrackerMetrics; track metric) {
            @if (metric.name) {
              <button (click)="onMetric(metric)" class="oph-select-menu-item">
                <span>{{ metric.name || '' }}</span>
              </button>
            }
          }
          @if (!state.selectedFilteredTrackerMetrics?.length) {
            <div class="empty">This tracker has no metrics.</div>
          }
        </mat-menu>

        <!-- --------------------OPERATOR--------------------------- -->
        <button
          class="select-button operator-button"
          [matMenuTriggerFor]="operatorMenu"
          [disabled]="
            !state.selectedMetric ||
            (state.selectedMetric?.type !== TrackerMetricTypes.Numeric &&
              state.selectedMetric?.type !== TrackerMetricTypes.Duration)
          "
          [class.disabled]="
            !state.selectedMetric ||
            (state.selectedMetric?.type !== TrackerMetricTypes.Numeric &&
              state.selectedMetric?.type !== TrackerMetricTypes.Duration)
          "
        >
          {{ triggerFormGroup.get('operator').value | operatorDisplay }}
          <img src="assets/img/icons/chevron-down-brown.svg" />
        </button>
        <mat-menu #operatorMenu="matMenu" class="oph-select-menu">
          @for (operator of operatorOptions; track operator) {
            <button (click)="onOperator(operator)" class="oph-select-menu-item">
              <div class="operator-container">
                <div class="operator">{{ operator.displayValue }}</div>
                <span class="operator-text">{{ operator.display }}</span>
              </div>
            </button>
          }
        </mat-menu>

        <!-- --------------------VALUE--------------------------- -->
        @if (!state.selectedMetric || state.selectedMetric?.type === TrackerMetricTypes.Numeric) {
          <input
            class="value-input"
            type="number"
            [min]="state.selectedMetric?.min || null"
            [max]="state.selectedMetric?.max || null"
            [value]="triggerFormGroup.get('value')?.value || ''"
            [disabled]="!state.selectedMetric"
            [class.disabled]="!state.selectedMetric"
            (input)="onValue($any($event.target).value)"
          />
        }

        @if (state.selectedMetric?.type === TrackerMetricTypes.Text) {
          <input
            class="value-input"
            type="text"
            [value]="triggerFormGroup.get('value')?.value || ''"
            [disabled]="!state.selectedMetric"
            [class.disabled]="!state.selectedMetric"
            (input)="onValue($any($event.target).value)"
          />
        }

        @if (state.selectedMetric?.type === TrackerMetricTypes.Select) {
          <button class="select-button" [matMenuTriggerFor]="selectValueMenu" [disabled]="!state.selectedMetric">
            <span>{{ triggerFormGroup.get('value').value || 'Select option' }}</span>
            <img src="assets/img/icons/chevron-down-brown.svg" />
          </button>
          <mat-menu #selectValueMenu="matMenu" class="oph-select-menu">
            @for (option of state.selectedMetric?.options | trackerMetricOptionsToStrings; track option) {
              <button (click)="onValue(option)" class="oph-select-menu-item">
                <span>{{ option || '' }}</span>
              </button>
            }
          </mat-menu>
        }

        @if (state.selectedMetric?.type === TrackerMetricTypes.Date) {
          <div class="date-picker-wrapper">
            <button class="select-button" (click)="dateInput.focus(); datePicker.open()">
              @if (triggerFormGroup.get('value')?.value) {
                <span>{{ triggerFormGroup.get('value')?.value | moment: 'M/D/YYYY' }}</span>
              } @else {
                <span>Select Date</span>
              }
              <img src="assets/img/icons/chevron-down-brown.svg" />
            </button>
            <input
              #dateInput
              class="date-picker-input"
              [matDatepicker]="datePicker"
              [value]="triggerFormGroup.get('value')?.value || ''"
              (dateInput)="onDateChange($event.value)"
              (dateChange)="onDateChange($event.value)"
            />
            <mat-datepicker #datePicker></mat-datepicker>
          </div>
        }

        @if (state.selectedMetric?.type === TrackerMetricTypes.Duration) {
          <oph-duration-input
            [control]="$any(triggerFormGroup.get('value'))"
            [fromTrigger]="true"
            [durationType]="$any(state.selectedMetric.durationType)"
          />
        }

        @if (state.selectedMetric?.type === TrackerMetricTypes.Boolean) {
          <button class="select-button" [matMenuTriggerFor]="selectBooleanMenu" [disabled]="!state.selectedMetric">
            @if (triggerFormGroup.get('value').value) {
              <span>{{ triggerFormGroup.get('value').value | numberToBoolean }}</span>
            } @else {
              <span>Select an option</span>
            }
            <img src="assets/img/icons/chevron-down-brown.svg" />
          </button>
          <mat-menu #selectBooleanMenu="matMenu" class="oph-select-menu">
            @for (option of booleanOptions; track option) {
              <button (click)="onValue(option.value)" class="oph-select-menu-item">
                <span>{{ option.display || '' }}</span>
              </button>
            }
          </mat-menu>
        }
      </div>
    }
    @if (hideXButton && triggerFormGroup.get('trackerId').value) {
      <oph-x-button (buttonClick)="onRemoveItem()"></oph-x-button>
    }
    @if (!hideXButton) {
      <oph-x-button (buttonClick)="onRemoveItem()"></oph-x-button>
    }
  </div>
}
